<template>
<el-dialog :title="!dataForm.id ? '新增' : '修改'" width="40%" :append-to-body="true" :close-on-click-modal="false" :visible.sync="view.visible">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()" label-width="0px" class="code-type-dialog-form" size="small">
        <div class="des_box">
            <el-descriptions class="margin-top" :column="2" size="small" border style="margin-bottom: 15px;">
                <el-descriptions-item label="零件编号" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="partCode" style="margin-bottom: 0;">
                        <el-input v-model="dataForm.partCode" placeholder="零件编号"></el-input>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="零件名称" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="partName" style="margin-bottom: 0;">
                        <el-input v-model="dataForm.partName" placeholder="零件名称"></el-input>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="单车用量" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="oneCarCount" style="margin-bottom: 0;">
                        <!-- <el-input
                                v-model="dataForm.oneCarCount"
                                placeholder="单车用量"
                            ></el-input> -->
                        <ctl-number v-model="dataForm.oneCarCount" :p="0" :min="0" :max="999" label="描述文字"></ctl-number>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="目标价格" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="targetPrice" style="margin-bottom: 0;">
                        <!-- <el-input
                                v-model="dataForm.targetPrice"
                                placeholder="目标价格"
                            ></el-input> -->
                        <ctl-number v-model="dataForm.targetPrice" :precision="3" :min="0" :max="999" label="描述文字"></ctl-number>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="供货状态" :label-style="getStyle()">
                    <el-form-item prop="supplyStatus" style="margin-bottom: 0;">
                        <!-- <el-select v-model="dataForm.supplyStatus">
                                <el-option key="1" label="/" :value="1" />
                                <el-option key="0" label="*" :value="0" />
                            </el-select> -->
                        <el-select size="small" v-model="dataForm.supplyStatus" placeholder="请选择供货状态" clearable>
                            <el-option v-for="item in SUPPLY_STATUS" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item></el-descriptions-item>
            </el-descriptions>
        </div>
    </el-form>
    <el-row>
        <el-col style="text-align: right">
            <el-button size="small" @click="view.visible = false">
                <span class="font-12 iconfont myicon-quxiao1"></span>&nbsp;取消
            </el-button>
            <el-button size="small" type="primary" plain @click="dataFormSubmit()" :loading="loading">
                <span class="font-12 iconfont myicon-tongguo"></span>&nbsp;保存
            </el-button>
        </el-col>
    </el-row>
</el-dialog>
</template>

<script>
import {
    // getLabelByValue,
    SUPPLY_STATUS,
} from "@/utils/const";
import {
    getPartById,
    createPart,
    editPart,
} from "@/controller/tech";
import CtlNumber from '@/views/common/ctl-number'
import {
    setLoading
} from "@/utils/index";
export default {
    data() {
        return {
            loading: false,
            view: {
                visible: false,
                conheight: {
                    height: this.$store.state.common.documentClientDefaultHeight *
                        0.9 -
                        410 +
                        "px",
                    "overflow-y": "auto",
                },
            },
            SUPPLY_STATUS: SUPPLY_STATUS,
            viewData: {},
            dataForm: {
                id: 0,
                partCode: "",
                partName: "",
                oneCarCount: "",
                targetPrice: "",
                supplyStatus: "",
                technicalId: "",
            },
            // 开始
            dataRule: {
                name: [{
                    required: true,
                    message: "编码名称不能为空",
                    trigger: "blur",
                }, ],
                type: [{
                    required: true,
                    message: "编码类型不能为空",
                    trigger: "blur",
                }, ],
            },
        };
    },
    components: {
        CtlNumber
    },
    methods: {
        // 初始化
        init(id, technicalId) {
            // debugger;
            this.dataForm.id = id || 0;
            this.dataForm.technicalId = technicalId;
            this.view.visible = true;
            this.loading = false
            this.$nextTick(() => {
                this.$refs["dataForm"].resetFields();
                if (this.dataForm.id) {
                    // 根据id查零件
                    getPartById({}, this.dataForm.id).then((data) => {
                        if (data && data.code === "00") {
                            this.dataForm = data.body;
                        }
                    });
                }
            });
        },
        // 表单提交
        dataFormSubmit() {
            this.loading = true
            setLoading()
            this.$refs["dataForm"].validate((valid) => {
                if (valid) {
                    let partParams = {
                        id: this.dataForm.id || undefined,
                        partCode: this.dataForm.partCode,
                        partName: this.dataForm.partName,
                        oneCarCount: this.dataForm.oneCarCount,
                        targetPrice: this.dataForm.targetPrice,
                        supplyStatus: this.dataForm.supplyStatus,
                        technicalId: this.dataForm.technicalId,
                    };
                    if (this.dataForm.id) {
                        // 更新零件
                        editPart(partParams)
                            .then((data) => {
                                if (data && data.code === "00") {
                                    this.$message({
                                        message: "操作成功",
                                        type: "success",
                                        duration: 1500,
                                        onClose: () => {
                                            this.view.visible = false;
                                            this.$emit(
                                                "refreshPartDataList"
                                            );
                                        },
                                    });
                                } else {
                                    this.$message.error(data.msg);
                                }
                            })
                            .catch((error) => {
                                console.log(error);
                            });
                    } else {
                        // 创建零件
                        createPart(partParams)
                            .then((data) => {
                                if (data && data.code === "00") {
                                    this.$message({
                                        message: "操作成功",
                                        type: "success",
                                        duration: 1500,
                                        onClose: () => {
                                            this.view.visible = false;
                                            this.$emit(
                                                "refreshPartDataList"
                                            );
                                        },
                                    });
                                } else {
                                    this.$message.error(data.msg);
                                }
                            })
                            .catch((error) => {
                                console.log(error);
                            });
                    }
                }
            });
        },
        getStyle() {
            return 'width: 100px; text-align: right'
        },
        getStyle2() {
            return 'width: 263.5px; text-align: center'
        }
    },
};
</script>

<style lang="scss" scoped>
.el-dialog__body {
    .code-type-dialog-form {
        width: 100%;
    }
}
</style>
